import React, {useEffect, useState} from 'react';
import './success.css';
import {Helmet} from "react-helmet";
import {Col, Row} from "react-bootstrap";
import {
    BsBookmarkCheckFill,
    BsFillPatchCheckFill,
    HiOutlineSpeakerphone,
} from "react-icons/all";

import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

const Success = () => {

    // Json Data
    const [success, setSuccess] = useState([]);

    useEffect(() => {
        fetch('./success.json')
            .then(res => res.json())
            .then(data => setSuccess(data))
    }, []);

    return (
        <div>
            <Helmet>
                <title> Success Story </title>
                <meta
                    name="Success Story"
                    content="This is Success Story page"
                />
            </Helmet>
            <div className="container faq" style={{position: 'relative'}}>
                <h2 className="title">Success Story</h2>
                <Row sm={1} md={4}>
                    {
                        success.map(person => <SuccessPerson
                                key={person.key}
                                person={person}
                            >
                            </SuccessPerson>
                        )
                    }
                </Row>
            </div>
        </div>
    );
};

function SuccessPerson(props) {

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const {name, batch, photo, description, specialist} = props.person;

    return (
        <Col>
            <div className="box">
                <div className="top-bar"></div>
                <div className="top">
                    <BsFillPatchCheckFill aria-hidden="true" className="text-success icon"/>

                    <div className="sbd-tooltip">
                        <BsBookmarkCheckFill className="icon"/>
                        <span className="sbd-tooltipText">Batch: <strong> {batch} </strong></span>
                    </div>

                </div>
                <div className="content">
                    <img className="img-thumbnail" src={photo} alt={name}/>
                    <h5>{name}</h5>
                    <p className="specialist">
                        {
                            specialist.map(count => <span> {count.one} {count.two} </span>)
                        }
                    </p>
                </div>
                <div className="btn">
                    <button onClick={openModal}><HiOutlineSpeakerphone aria-hidden="true"/> Student Statement</button>
                </div>
            </div>


            {/* Modal */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="sbd-modal">
                    <div className="modal-header border-bottom px-4 pt-4">
                        <h4 className="fw-bolder m-0"> {name} </h4>
                        <button className="btn btn-danger" onClick={closeModal}>close</button>
                    </div>

                    <div className="modal-content border-0 p-4">
                        <h2> Student Statement </h2>
                        {description}
                    </div>
                </div>
            </Modal>
        </Col>
    );
}

export default Success;